import { render, staticRenderFns } from "./SmallBasicPremiumCard.vue?vue&type=template&id=2b38af36&"
import script from "./SmallBasicPremiumCard.vue?vue&type=script&lang=js&"
export * from "./SmallBasicPremiumCard.vue?vue&type=script&lang=js&"
import style0 from "./SmallBasicPremiumCard.vue?vue&type=style&index=0&id=2b38af36&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports